import React, { Component } from "react";
import { Modal, Glyphicon } from "react-bootstrap";

class Header extends Component {
  render() {
    const { title, glyph, closeButton } = this.props;

    let glyphContents = null;
    if (glyph) {
      glyphContents = <Glyphicon glyph={glyph} />;
    }

    let contents = null;
    if (title) {
      contents = (
        <Modal.Header closeButton={closeButton}>
          <Modal.Title>
            {glyphContents}
            {title}
          </Modal.Title>
        </Modal.Header>
      );
    }
    return contents;
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Core/Components/ModalParts/Header.js